import { connect } from "react-redux";
import MiniBag from "./MiniBag";
import { getBagItems, getLoading } from "../../state/modules/bag";
import { getDefaultStoreUrl } from "../../state/modules/regionalStore";

const mapStateToProps = state => {
  return {
    defaultStoreUrl: getDefaultStoreUrl(state),
    items: getBagItems(state),
    loading: getLoading(state)
  };
};

export default connect(mapStateToProps)(MiniBag);



// WEBPACK FOOTER //
// ./template/components/MiniBag/index.js